import { endPoints, requestType } from "../constants/variables";
import Api from "./index";

const createSession = (payload) => {
  return Api(endPoints.createFaceLivenessSession, payload, requestType.POST);
};

// const createSession = (payload, token) => {
//   return Api(
//     endPoints.createFaceLivenessSession,
//     payload,
//     requestType.POST,
//     token
//   );
// };

const startVerification = (sessionId) => {
  return Api(
    `${endPoints.startVerificationSession}/${sessionId}/start`,
    null,
    requestType.POST
  );
};

const verifyProcess = (sessionId, payload) => {
  return Api(
    `${endPoints.verifyFace}/${sessionId}/update`,
    payload,
    requestType.POST
  );
};

const trackPageVisiting = (sessionId) => {
  return Api(
    `${endPoints.trackPageVisiting}/${sessionId}/track`,
    null,
    requestType.POST
  );
};

export { createSession, startVerification, verifyProcess, trackPageVisiting };
